import React from "react";

// Slow editorial marquee — CSS driven, monochrome.
export const Marquee = ({ text = "SIMPLICITY IS FREEDOM", separator = "—" }) => {
    const chunk = (
        <span className="inline-flex items-center">
            {Array.from({ length: 8 }).map((_, i) => (
                <span key={i} className="inline-flex items-center">
                    <span className="font-serif italic text-ink/90 text-[7vw] md:text-[5vw] leading-none px-8">
                        {text}
                    </span>
                    <span className="text-ink/30 text-[4vw] md:text-[2.6vw] px-2">
                        {separator}
                    </span>
                </span>
            ))}
        </span>
    );
    return (
        <div className="w-full overflow-hidden border-y border-line py-6 select-none">
            <div className="marquee-track">
                {chunk}
                {chunk}
            </div>
        </div>
    );
};
